export const PREFIX_SUFFIX_MAX_CHAR_COUNT = 32;
